import { useState, useEffect } from "react";
import { LoginToken } from "../Utility/common";
import Skeleton from "react-loading-skeleton";
import { useLocation } from "react-router-dom";
import HelpWantedCard from "./HelpWantedCard";
import { Capacitor } from "@capacitor/core";
import queryString from "query-string";
import Cookies from "js-cookie";
import config from "../../config";

const HelpWanted = ({ profiles, logInUsername }) => {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loginToken = Capacitor.isNativePlatform()
    ? params.token
    : Cookies.get("LoginToken");

  useEffect(() => {
    setLoading(true); // ✅ reset loading on re-run
    fetch(`${config.genni.marketing_portal.API_KEY}/creatorapi/helpwanted`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": loginToken,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Fetch failed");
        return res.json();
      })
      .then((d) => {
        setData(Array.isArray(d?.data) ? d.data : []);
      })
      .catch(() => {
        setData([]); // Fallback to empty
      })
      .finally(() => {
        setLoading(false);
      });
  }, [loginToken]);

  const renderSkeletons = () => {
    return Array.from({ length: 3 }, (_, i) => (
      <div style={{ width: "100%" }} key={`skeleton-${i}`}>
        <div
          className="post-card post-card-skeleton bg-white mb-3"
          style={{
            minHeight: 222,
            height: 222,
            width: "100%",
            background: "#fff",
          }}
        >
          <div className="card-media mb-15 d-flex jc-space-between">
            <div className="d-flex flex-col">
              <div className="media mr-10 mb-3">
                <Skeleton
                  width="40px"
                  height="40px"
                  baseColor="#e6ebf2"
                  highlightColor="#f0f4f7"
                />
              </div>
              <div className="d-flex mt-15 flex-col">
                <Skeleton
                  width="140px"
                  height="20px"
                  baseColor="#e6ebf2"
                  highlightColor="#f0f4f7"
                  className="mb-1"
                />
                <Skeleton
                  width="222px"
                  height="15px"
                  baseColor="#e6ebf2"
                  highlightColor="#f0f4f7"
                  className="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  if (loading) {
    return (
      <div className="slider-grid slider-grid-mobile pb-2">
        {renderSkeletons()}
      </div>
    );
  }

  if (!data.length) {
    return (
      <div
        className="card w-100 py-2 px-4 d-flex flex-column align-items-center justify-content-center"
        style={{ textAlign: "center", minHeight: 250 }}
      >
        <h4 className="madeGentle mb-2">Nothing Here — For Now</h4>
        <p className="text-muted mb-3" style={{ maxWidth: 700 }}>
          There aren't any help wanted opportunities available right now. In the meantime, check out
          our{" "}
          <a
            className="text-pink"
            href={`/contests${
              Capacitor.isNativePlatform() ? `?token=${LoginToken()}` : ""
            }`}
          >
            ongoing contests
          </a>{" "}
          to keep earning.
        </p>
        <a
          href={`/contests${
            Capacitor.isNativePlatform() ? `?token=${LoginToken()}` : ""
          }`}
          className="btn btn-primary"
        >
          Browse Contests
        </a>
      </div>
    );
  }

  return (
    <div
      className="slider-grid slider-grid-mobile pb-2"
      style={{ overflowX: "hidden" }}
    >
      {data.map((e) => (
        <HelpWantedCard logInUsername={logInUsername} key={e.id} e={e} profiles={profiles} />
      ))}
      {/* <p>{data.length}</p> */}
    </div>
  );
};

export default HelpWanted;
